import { LocalFileSystemID, FailureType } from '../shared/types';
import { createURI } from '../shared/utils/URI';
import { CommandID } from '../commands';
import { command$ } from '../observables/command';
import { error$ } from '../observables/error';
export default function (id, path, selected, copyTo, isRoot, isParent) {
    return [
        ...(isParent ? [] : [
            {
                id: CommandID.Download,
                label: 'Download',
                click: () => command$.next({ id: CommandID.Download, uri: createURI(id, path) }),
                separator: isRoot
            }
        ]),
        ...((isParent || isRoot) ? [] : [
            {
                id: CommandID.MirrorRemote,
                label: 'Download with Relative Path',
                click: () => command$.next({ id: CommandID.MirrorRemote, uri: createURI(id, path) }),
                separator: true
            },
        ]),
        ...(isParent ? [] : [
            {
                id: 'new-dir',
                label: 'New Folder...',
                click: () => command$.next({ id: CommandID.NewDir })
            },
            {
                id: 'new-file',
                label: 'New File...',
                click: () => command$.next({ id: CommandID.NewFile }),
                separator: true
            }
        ]),
        {
            id: CommandID.TriggerCopy,
            label: 'Copy',
            click: () => command$.next({ id: CommandID.TriggerCopy }),
        },
        {
            id: CommandID.CopyURI,
            label: 'Copy URL',
            click: () => command$.next({ id: CommandID.CopyURI, uri: createURI(id, path) })
        },
        {
            id: CommandID.CopyPath,
            label: 'Copy Path',
            click: () => command$.next({ id: CommandID.CopyPath, uri: createURI(id, path) })
        },
        ...((isParent || isRoot) ? [] : [
            {
                id: CommandID.CopyRelativePath,
                label: 'Copy Relative Path',
                click: () => command$.next({ id: CommandID.CopyRelativePath, uri: createURI(LocalFileSystemID, path) })
            }
        ]),
        {
            id: CommandID.CopyName,
            label: 'Copy Name',
            click: () => command$.next({ id: CommandID.CopyName, uri: createURI(id, path) }),
            separator: !isParent
        },
        ...((isParent || isRoot) ? [] : [
            {
                id: 'rename',
                label: 'Rename...',
                click: () => command$.next({ id: CommandID.Rename, uri: createURI(id, path) })
            },
            {
                id: CommandID.Duplicate,
                label: 'Duplicate',
                click: () => command$.next({ id: CommandID.Duplicate, uri: createURI(id, path) })
            },
            {
                id: 'delete',
                label: 'Delete',
                className: 'attention',
                click: () => {
                    error$.next({
                        type: FailureType.ConfirmDeletion,
                        files: ((selected.length && selected.includes(path)) ? selected : [path]).map(path => createURI(id, path))
                    });
                },
                separator: true
            }
        ]),
        ...(isParent ? [] : [
            {
                id: 'refresh',
                label: 'Refresh',
                click: () => command$.next({ id: CommandID.Refresh })
            }
        ])
    ];
}
